import type { IDropdownsIconType } from "./types";

export const dropdownIcons: IDropdownsIconType = {
  gender: { name: "Men", type: "broken" },
  paymentMethod: "WalletMoney",
  relationship: "UsersGroupTwoRounded",
  doctorEducation: "SquareAcademicCap",
  familyMember: "UsersGroupTwoRounded",
  hfType: "Hospital",
  languageSkills: "ChatRoundCheck",
  medicalDeviceType: "MedicalKit",
  visitType: "MonitorCamera",
  orderType: "TestTube",
  country: "Globus",
  speciality: "MedalStarSquare",
  subSpeciality: "MedalStarSquare",
  medicineName: "Pills",
  medicineType: "Pills",
  medicineFormulation: "Pills",
  dosage: "Pills",
  days: "Calendar",
  state: "StreetsMapPoint",
  city: "MapPoint",
  timezone: "ClockCircle",
  countryTimezone: "ClockCircle",
  allDepartments: "Buildings",
  testType: "TestTube",
  notifiableRoleType: "User",
  messagingRoleType: "User",
  messagingUsersList: "User",
  deviceType: "MedicalKit",
  userName: "User",
  familyMemberWithParent: "UsersGroupTwoRounded",
  reuseInterval: "CalendarAdd",
  usageApproach: "TestTube",
  usageDuration: "ClockCircle",
  usageAmount: "HandPills",
  visitHistories: "Calendar",
  mspType: "Hospital",
};
